import { default as module } from './AbstractModule';
import { lerp } from '../utils/maths'

export default class extends module {
    constructor(m) {
        super(m);

        this.active = false

        this.target = {x:0,y:0};
        this.position = {x:0,y:0};
    }

    init() {

    }

    setActive(value = true) {
        if(value == true) {
            if(!this.active) {
                this.active = true
                this.update()
            }
        } else {
            cancelAnimationFrame(this.raf)
            this.active = false
        }
    }

    setTarget(args) {
        this.target = args.value

        if(args.force)
            this.position = this.target
    }

    update() {
        this.position.x = lerp(this.position.x, this.target.x, 0.1);
        this.position.y = lerp(this.position.y, this.target.y, 0.1);
        TweenMax.set(this.el, { x: this.position.x, y: this.position.y, force3D: true })

        this.raf = requestAnimationFrame(this.update.bind(this))
    }
}
